import {registerRoute as workbox_routing_registerRoute} from '/vercel/path0/node_modules/workbox-routing/registerRoute.mjs';
import {NetworkFirst as workbox_strategies_NetworkFirst} from '/vercel/path0/node_modules/workbox-strategies/NetworkFirst.mjs';
import {ExpirationPlugin as workbox_expiration_ExpirationPlugin} from '/vercel/path0/node_modules/workbox-expiration/ExpirationPlugin.mjs';
import {CacheFirst as workbox_strategies_CacheFirst} from '/vercel/path0/node_modules/workbox-strategies/CacheFirst.mjs';
import {StaleWhileRevalidate as workbox_strategies_StaleWhileRevalidate} from '/vercel/path0/node_modules/workbox-strategies/StaleWhileRevalidate.mjs';
import {RangeRequestsPlugin as workbox_range_requests_RangeRequestsPlugin} from '/vercel/path0/node_modules/workbox-range-requests/RangeRequestsPlugin.mjs';
import {clientsClaim as workbox_core_clientsClaim} from '/vercel/path0/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/vercel/path0/node_modules/workbox-precaching/precacheAndRoute.mjs';
import {cleanupOutdatedCaches as workbox_precaching_cleanupOutdatedCaches} from '/vercel/path0/node_modules/workbox-precaching/cleanupOutdatedCaches.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */


importScripts(
  
);







self.skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "/_next/static/MvGtYn4tUlRyUvNqJLyui/_buildManifest.js",
    "revision": "6c4ca04eb2f3580a02c947e39f3b7c3a"
  },
  {
    "url": "/_next/static/MvGtYn4tUlRyUvNqJLyui/_ssgManifest.js",
    "revision": "b6652df95db52feb4daf4eca35380933"
  },
  {
    "url": "/_next/static/chunks/1404-22ad8836386a0376.js",
    "revision": "22ad8836386a0376"
  },
  {
    "url": "/_next/static/chunks/1404-22ad8836386a0376.js.map",
    "revision": "03e2051d94e3cd3bcd35eec2cb2d2410"
  },
  {
    "url": "/_next/static/chunks/1664-96c2c6520198584d.js",
    "revision": "96c2c6520198584d"
  },
  {
    "url": "/_next/static/chunks/1664-96c2c6520198584d.js.map",
    "revision": "e8205c22f0bf68cf3bbb7411628fc12c"
  },
  {
    "url": "/_next/static/chunks/1845-af5e4e2093706244.js",
    "revision": "af5e4e2093706244"
  },
  {
    "url": "/_next/static/chunks/1845-af5e4e2093706244.js.map",
    "revision": "96733707737832d0527091f39e95de44"
  },
  {
    "url": "/_next/static/chunks/2474-7d806e9bbb1615a0.js",
    "revision": "7d806e9bbb1615a0"
  },
  {
    "url": "/_next/static/chunks/2474-7d806e9bbb1615a0.js.map",
    "revision": "e05cc0ee19b4a4b5faf47b70a7b8b6b2"
  },
  {
    "url": "/_next/static/chunks/2710-fd960fe2da5dd2dc.js",
    "revision": "fd960fe2da5dd2dc"
  },
  {
    "url": "/_next/static/chunks/2710-fd960fe2da5dd2dc.js.map",
    "revision": "ffa0c60963f9382905120fda7a84c053"
  },
  {
    "url": "/_next/static/chunks/289-183a1ca1d4ad0c90.js",
    "revision": "183a1ca1d4ad0c90"
  },
  {
    "url": "/_next/static/chunks/289-183a1ca1d4ad0c90.js.map",
    "revision": "9d6e7707f84f94cd9beb04e276207d8f"
  },
  {
    "url": "/_next/static/chunks/2962-7156aa2ca4fa6f2f.js",
    "revision": "7156aa2ca4fa6f2f"
  },
  {
    "url": "/_next/static/chunks/2962-7156aa2ca4fa6f2f.js.map",
    "revision": "5895a9486b6ed237e36a1f315bd8ad3e"
  },
  {
    "url": "/_next/static/chunks/3027-0034cd6d88e4ff61.js",
    "revision": "0034cd6d88e4ff61"
  },
  {
    "url": "/_next/static/chunks/3415-9b0d2a71e2914e81.js",
    "revision": "9b0d2a71e2914e81"
  },
  {
    "url": "/_next/static/chunks/3415-9b0d2a71e2914e81.js.map",
    "revision": "3d2d65fd95dc19b7cb58dbe1dd9a8959"
  },
  {
    "url": "/_next/static/chunks/3445-7230794a97f92025.js",
    "revision": "7230794a97f92025"
  },
  {
    "url": "/_next/static/chunks/3445-7230794a97f92025.js.map",
    "revision": "0332283d095153a4fd73cbb5fb15c240"
  },
  {
    "url": "/_next/static/chunks/3766-69369faabb17b92e.js",
    "revision": "69369faabb17b92e"
  },
  {
    "url": "/_next/static/chunks/3766-69369faabb17b92e.js.map",
    "revision": "fac8736a1b7e7b99f5fb06a8691be940"
  },
  {
    "url": "/_next/static/chunks/3fff1979-c60b734589cf770c.js",
    "revision": "c60b734589cf770c"
  },
  {
    "url": "/_next/static/chunks/3fff1979-c60b734589cf770c.js.map",
    "revision": "ee6a8d9539c3b6225379de8445fef749"
  },
  {
    "url": "/_next/static/chunks/4637-c551b8743c61aa12.js",
    "revision": "c551b8743c61aa12"
  },
  {
    "url": "/_next/static/chunks/4637-c551b8743c61aa12.js.map",
    "revision": "10615dadd2836b48bf561d24c1b978e9"
  },
  {
    "url": "/_next/static/chunks/4896-2e31995cbe498cad.js",
    "revision": "2e31995cbe498cad"
  },
  {
    "url": "/_next/static/chunks/4896-2e31995cbe498cad.js.map",
    "revision": "42c3149e0ee14ec7d8a1345be4a3aff2"
  },
  {
    "url": "/_next/static/chunks/4964-e12de282d4730242.js",
    "revision": "e12de282d4730242"
  },
  {
    "url": "/_next/static/chunks/4964-e12de282d4730242.js.map",
    "revision": "9c7ddae97742031e78d2bcac45454ba7"
  },
  {
    "url": "/_next/static/chunks/53-434a6a68b84d6aa2.js",
    "revision": "434a6a68b84d6aa2"
  },
  {
    "url": "/_next/static/chunks/53-434a6a68b84d6aa2.js.map",
    "revision": "6cf11136a7f3e4da38d0e23eef37ded5"
  },
  {
    "url": "/_next/static/chunks/5675-8b096c07483927e2.js",
    "revision": "8b096c07483927e2"
  },
  {
    "url": "/_next/static/chunks/5675-8b096c07483927e2.js.map",
    "revision": "7f10cbddd896afafe3f0c2558fc893e6"
  },
  {
    "url": "/_next/static/chunks/588-60ac40e5ada6fa18.js",
    "revision": "60ac40e5ada6fa18"
  },
  {
    "url": "/_next/static/chunks/588-60ac40e5ada6fa18.js.map",
    "revision": "86cc6ad73bde74e957b334b05604bcaa"
  },
  {
    "url": "/_next/static/chunks/7066-229a8b68ed083bd0.js",
    "revision": "229a8b68ed083bd0"
  },
  {
    "url": "/_next/static/chunks/7066-229a8b68ed083bd0.js.map",
    "revision": "364957c842b46784d5fc19928f7e23fa"
  },
  {
    "url": "/_next/static/chunks/7334-9044507134fe2e69.js",
    "revision": "9044507134fe2e69"
  },
  {
    "url": "/_next/static/chunks/7334-9044507134fe2e69.js.map",
    "revision": "5679fee72c03106aaca96797372001f1"
  },
  {
    "url": "/_next/static/chunks/75fc9c18-bf07ef36d2dad8e8.js",
    "revision": "bf07ef36d2dad8e8"
  },
  {
    "url": "/_next/static/chunks/75fc9c18-bf07ef36d2dad8e8.js.map",
    "revision": "35738b472893ac2ff2c25474a739d3dd"
  },
  {
    "url": "/_next/static/chunks/8100-3640a090d699af87.js",
    "revision": "3640a090d699af87"
  },
  {
    "url": "/_next/static/chunks/8100-3640a090d699af87.js.map",
    "revision": "5c79529b8524ccea701767bb7254ddb8"
  },
  {
    "url": "/_next/static/chunks/8467-c8a0b4158f8461a7.js",
    "revision": "c8a0b4158f8461a7"
  },
  {
    "url": "/_next/static/chunks/8467-c8a0b4158f8461a7.js.map",
    "revision": "3982f421e52841dff1ecd65af8bc2016"
  },
  {
    "url": "/_next/static/chunks/8516-75294a9f029f194d.js",
    "revision": "75294a9f029f194d"
  },
  {
    "url": "/_next/static/chunks/8516-75294a9f029f194d.js.map",
    "revision": "565d933785040f6fd222677a31a3cb12"
  },
  {
    "url": "/_next/static/chunks/891-6cf9e224b76c8654.js",
    "revision": "6cf9e224b76c8654"
  },
  {
    "url": "/_next/static/chunks/891-6cf9e224b76c8654.js.map",
    "revision": "5b7e1b4711a13e5aef112efc34b3cda8"
  },
  {
    "url": "/_next/static/chunks/94726e6d-bf2e4e53196e3dc0.js",
    "revision": "bf2e4e53196e3dc0"
  },
  {
    "url": "/_next/static/chunks/94726e6d-bf2e4e53196e3dc0.js.map",
    "revision": "e2592c499b62fedfa3e268dface7f793"
  },
  {
    "url": "/_next/static/chunks/e8ab3f79-31652ced219fb612.js",
    "revision": "31652ced219fb612"
  },
  {
    "url": "/_next/static/chunks/e8ab3f79-31652ced219fb612.js.map",
    "revision": "d12c1709521d29a895fac55fdbea335f"
  },
  {
    "url": "/_next/static/chunks/framework-687aa89229af1deb.js",
    "revision": "687aa89229af1deb"
  },
  {
    "url": "/_next/static/chunks/framework-687aa89229af1deb.js.map",
    "revision": "07c08b37f69ebd0cf6b5511d6f7971ef"
  },
  {
    "url": "/_next/static/chunks/main-7a2633415a6cbbbd.js",
    "revision": "7a2633415a6cbbbd"
  },
  {
    "url": "/_next/static/chunks/main-7a2633415a6cbbbd.js.map",
    "revision": "44d03f408bbd92fe8ea1463bf59aadb4"
  },
  {
    "url": "/_next/static/chunks/pages/_app-1be0f6401745448c.js",
    "revision": "1be0f6401745448c"
  },
  {
    "url": "/_next/static/chunks/pages/_app-1be0f6401745448c.js.map",
    "revision": "fb7e5c16a18e5fdcc81a4407c144239a"
  },
  {
    "url": "/_next/static/chunks/pages/_error-d8a9931451140408.js",
    "revision": "d8a9931451140408"
  },
  {
    "url": "/_next/static/chunks/pages/_error-d8a9931451140408.js.map",
    "revision": "af8cedf98399f321d6c0b5e4bc2cdaaf"
  },
  {
    "url": "/_next/static/chunks/pages/assessment-6d2d495a24333b74.js",
    "revision": "6d2d495a24333b74"
  },
  {
    "url": "/_next/static/chunks/pages/assessment-6d2d495a24333b74.js.map",
    "revision": "cf44e07b6e6c90bafa2b8bcb5c61bd09"
  },
  {
    "url": "/_next/static/chunks/pages/assessment/%5Bslug%5D-cc119eecc840fead.js",
    "revision": "cc119eecc840fead"
  },
  {
    "url": "/_next/static/chunks/pages/assessment/%5Bslug%5D-cc119eecc840fead.js.map",
    "revision": "092315229bc19710039a06806e89b9c0"
  },
  {
    "url": "/_next/static/chunks/pages/assessment/%5Bslug%5D/%5Bquestion%5D-adb2a78c39b2db4b.js",
    "revision": "adb2a78c39b2db4b"
  },
  {
    "url": "/_next/static/chunks/pages/assessment/%5Bslug%5D/%5Bquestion%5D-adb2a78c39b2db4b.js.map",
    "revision": "966757bb7dd433bae5390665353cdc35"
  },
  {
    "url": "/_next/static/chunks/pages/backoffice-d4184192bc9c9afd.js",
    "revision": "d4184192bc9c9afd"
  },
  {
    "url": "/_next/static/chunks/pages/backoffice-d4184192bc9c9afd.js.map",
    "revision": "c45ef942f3418dcd02b5a5427033e571"
  },
  {
    "url": "/_next/static/chunks/pages/blog-c6213037c716f4a0.js",
    "revision": "c6213037c716f4a0"
  },
  {
    "url": "/_next/static/chunks/pages/blog-c6213037c716f4a0.js.map",
    "revision": "914ba0b77911a74d913637b6e5f1b3ae"
  },
  {
    "url": "/_next/static/chunks/pages/blog/%5Bslug%5D-7ff1f61f2709fca1.js",
    "revision": "7ff1f61f2709fca1"
  },
  {
    "url": "/_next/static/chunks/pages/blog/%5Bslug%5D-7ff1f61f2709fca1.js.map",
    "revision": "59de7ef0392c679e3843f63838f7b372"
  },
  {
    "url": "/_next/static/chunks/pages/blog/premium/%5Bslug%5D-f0a6676fb2b0e386.js",
    "revision": "f0a6676fb2b0e386"
  },
  {
    "url": "/_next/static/chunks/pages/blog/premium/%5Bslug%5D-f0a6676fb2b0e386.js.map",
    "revision": "3b7ca64055b5a666b09d6416a87542ca"
  },
  {
    "url": "/_next/static/chunks/pages/dashboard-03d0dbef6cc81d90.js",
    "revision": "03d0dbef6cc81d90"
  },
  {
    "url": "/_next/static/chunks/pages/dashboard-03d0dbef6cc81d90.js.map",
    "revision": "e3e862da85353dbb423d191c79b69994"
  },
  {
    "url": "/_next/static/chunks/pages/faq-a2a5a685e48fb6e7.js",
    "revision": "a2a5a685e48fb6e7"
  },
  {
    "url": "/_next/static/chunks/pages/faq-a2a5a685e48fb6e7.js.map",
    "revision": "ed4497e9b5f456abdcd628ac3e6734dd"
  },
  {
    "url": "/_next/static/chunks/pages/get-started-e34395bd942a6271.js",
    "revision": "e34395bd942a6271"
  },
  {
    "url": "/_next/static/chunks/pages/get-started-e34395bd942a6271.js.map",
    "revision": "6f9d5f887172393378507bb2bd50f106"
  },
  {
    "url": "/_next/static/chunks/pages/growing-together-e775696c499cce06.js",
    "revision": "e775696c499cce06"
  },
  {
    "url": "/_next/static/chunks/pages/growing-together-e775696c499cce06.js.map",
    "revision": "09f707e8e687190383df9fdbfe200932"
  },
  {
    "url": "/_next/static/chunks/pages/growing-together/%5Bslug%5D-1ea72807ae3fa7ed.js",
    "revision": "1ea72807ae3fa7ed"
  },
  {
    "url": "/_next/static/chunks/pages/growing-together/%5Bslug%5D-1ea72807ae3fa7ed.js.map",
    "revision": "3d4674286d9ca29708fd6735255ea673"
  },
  {
    "url": "/_next/static/chunks/pages/how-it-works-eff5403495259695.js",
    "revision": "eff5403495259695"
  },
  {
    "url": "/_next/static/chunks/pages/how-it-works-eff5403495259695.js.map",
    "revision": "c374954d983d1847c09ce0f499b59aee"
  },
  {
    "url": "/_next/static/chunks/pages/in-depth-report-c5462accd327281d.js",
    "revision": "c5462accd327281d"
  },
  {
    "url": "/_next/static/chunks/pages/in-depth-report-c5462accd327281d.js.map",
    "revision": "e79ccc90685dcd97841b768bb64d0d2f"
  },
  {
    "url": "/_next/static/chunks/pages/in-depth-report/family-history-bdce28e2879b4a49.js",
    "revision": "bdce28e2879b4a49"
  },
  {
    "url": "/_next/static/chunks/pages/in-depth-report/family-history-bdce28e2879b4a49.js.map",
    "revision": "4851595eadb5b3a26052a21246e647c2"
  },
  {
    "url": "/_next/static/chunks/pages/in-depth-report/family-planning-5e1ffad8762a9cac.js",
    "revision": "5e1ffad8762a9cac"
  },
  {
    "url": "/_next/static/chunks/pages/in-depth-report/family-planning-5e1ffad8762a9cac.js.map",
    "revision": "0fa7e428c70cd3dbbf819332fd45b2ab"
  },
  {
    "url": "/_next/static/chunks/pages/in-depth-report/lifestyle-f13cc14bd57b645b.js",
    "revision": "f13cc14bd57b645b"
  },
  {
    "url": "/_next/static/chunks/pages/in-depth-report/lifestyle-f13cc14bd57b645b.js.map",
    "revision": "8b1cad5451e420a6eb59039312d42841"
  },
  {
    "url": "/_next/static/chunks/pages/in-depth-report/medical-history-9d7868e4ced43e55.js",
    "revision": "9d7868e4ced43e55"
  },
  {
    "url": "/_next/static/chunks/pages/in-depth-report/medical-history-9d7868e4ced43e55.js.map",
    "revision": "0a76eee9a3d90e76e848266cbad70dd8"
  },
  {
    "url": "/_next/static/chunks/pages/in-depth-report/mental-health-69f6030d54952f7c.js",
    "revision": "69f6030d54952f7c"
  },
  {
    "url": "/_next/static/chunks/pages/in-depth-report/mental-health-69f6030d54952f7c.js.map",
    "revision": "e9e71cad6fc777906c91ea8ca2f2feea"
  },
  {
    "url": "/_next/static/chunks/pages/in-depth-report/period-health-85197a3338b3c1c9.js",
    "revision": "85197a3338b3c1c9"
  },
  {
    "url": "/_next/static/chunks/pages/in-depth-report/period-health-85197a3338b3c1c9.js.map",
    "revision": "2042cae8240072145238ee7cd94dd222"
  },
  {
    "url": "/_next/static/chunks/pages/in-depth-report/reproductive-health-b8de0aa45fa632b6.js",
    "revision": "b8de0aa45fa632b6"
  },
  {
    "url": "/_next/static/chunks/pages/in-depth-report/reproductive-health-b8de0aa45fa632b6.js.map",
    "revision": "55e2e3b4ee1609c17b78b1fb2451680a"
  },
  {
    "url": "/_next/static/chunks/pages/in-depth-report/sexual-wellbeing-a2b3ad36b5052352.js",
    "revision": "a2b3ad36b5052352"
  },
  {
    "url": "/_next/static/chunks/pages/in-depth-report/sexual-wellbeing-a2b3ad36b5052352.js.map",
    "revision": "6ba01a4dc708c199edc113482bcbfa74"
  },
  {
    "url": "/_next/static/chunks/pages/index-f64c2b19f867077d.js",
    "revision": "f64c2b19f867077d"
  },
  {
    "url": "/_next/static/chunks/pages/index-f64c2b19f867077d.js.map",
    "revision": "749e963c5fb7931cc2b6554c4d158420"
  },
  {
    "url": "/_next/static/chunks/pages/mira-23f568d231ac68b3.js",
    "revision": "23f568d231ac68b3"
  },
  {
    "url": "/_next/static/chunks/pages/mira-23f568d231ac68b3.js.map",
    "revision": "ca9643199566eb62214ddefca317b717"
  },
  {
    "url": "/_next/static/chunks/pages/next-steps-68f41bf35677c9dc.js",
    "revision": "68f41bf35677c9dc"
  },
  {
    "url": "/_next/static/chunks/pages/next-steps-68f41bf35677c9dc.js.map",
    "revision": "ded73e9c19238f1daf4d7f6435bca4fe"
  },
  {
    "url": "/_next/static/chunks/pages/outro-8eebfb5bd9e56f00.js",
    "revision": "8eebfb5bd9e56f00"
  },
  {
    "url": "/_next/static/chunks/pages/outro-8eebfb5bd9e56f00.js.map",
    "revision": "0b61c221b7eae015bd9c867e00850698"
  },
  {
    "url": "/_next/static/chunks/pages/pay-5d1e398b8b1fc07d.js",
    "revision": "5d1e398b8b1fc07d"
  },
  {
    "url": "/_next/static/chunks/pages/pay-5d1e398b8b1fc07d.js.map",
    "revision": "d28c9f8385bf528dff35701e452006f0"
  },
  {
    "url": "/_next/static/chunks/pages/pre-order-cf693d8ebcea597d.js",
    "revision": "cf693d8ebcea597d"
  },
  {
    "url": "/_next/static/chunks/pages/pre-order-cf693d8ebcea597d.js.map",
    "revision": "a4c515a5cf2b4cc5f6ba92e04e99ac24"
  },
  {
    "url": "/_next/static/chunks/pages/premium-d367d153655dd1a0.js",
    "revision": "d367d153655dd1a0"
  },
  {
    "url": "/_next/static/chunks/pages/premium-d367d153655dd1a0.js.map",
    "revision": "df0df339ceccfdde619b7d8527bab946"
  },
  {
    "url": "/_next/static/chunks/pages/privacy-policy-8125af6b46eaa1e2.js",
    "revision": "8125af6b46eaa1e2"
  },
  {
    "url": "/_next/static/chunks/pages/privacy-policy-8125af6b46eaa1e2.js.map",
    "revision": "9c6638c82bac8ece3f6bde92ba42f169"
  },
  {
    "url": "/_next/static/chunks/pages/profile-31ee6632b320fcfe.js",
    "revision": "31ee6632b320fcfe"
  },
  {
    "url": "/_next/static/chunks/pages/profile-31ee6632b320fcfe.js.map",
    "revision": "52690238df3a671553683cb460ef18ca"
  },
  {
    "url": "/_next/static/chunks/pages/science-da4747097e5e957a.js",
    "revision": "da4747097e5e957a"
  },
  {
    "url": "/_next/static/chunks/pages/science-da4747097e5e957a.js.map",
    "revision": "cc21a53c8a152ee5a69e226698755400"
  },
  {
    "url": "/_next/static/chunks/pages/sitemap.xml-8ea43093c95db9f1.js",
    "revision": "8ea43093c95db9f1"
  },
  {
    "url": "/_next/static/chunks/pages/sitemap.xml-8ea43093c95db9f1.js.map",
    "revision": "358d49dc985ff5470c03937fc9141cc0"
  },
  {
    "url": "/_next/static/chunks/pages/sources-d584403ff14f66c3.js",
    "revision": "d584403ff14f66c3"
  },
  {
    "url": "/_next/static/chunks/pages/sources-d584403ff14f66c3.js.map",
    "revision": "93c2d1c51758bec9fcb90fe9030174d4"
  },
  {
    "url": "/_next/static/chunks/pages/story-32f4cea0810ac543.js",
    "revision": "32f4cea0810ac543"
  },
  {
    "url": "/_next/static/chunks/pages/story-32f4cea0810ac543.js.map",
    "revision": "ead7a7368993dd0b99ac986e07bcedc6"
  },
  {
    "url": "/_next/static/chunks/pages/success-df00a10f0f4e7609.js",
    "revision": "df00a10f0f4e7609"
  },
  {
    "url": "/_next/static/chunks/pages/success-df00a10f0f4e7609.js.map",
    "revision": "ac05555a94163b1054196c26a45f6a2f"
  },
  {
    "url": "/_next/static/chunks/pages/terms-of-service-80f89cc1adcb9a35.js",
    "revision": "80f89cc1adcb9a35"
  },
  {
    "url": "/_next/static/chunks/pages/terms-of-service-80f89cc1adcb9a35.js.map",
    "revision": "fada95dbffa87d0c05309c5e4b7039e9"
  },
  {
    "url": "/_next/static/chunks/polyfills-78c92fac7aa8fdd8.js",
    "revision": "79330112775102f91e1010318bae2bd3"
  },
  {
    "url": "/_next/static/chunks/webpack-8092fa1cf3aac69a.js",
    "revision": "8092fa1cf3aac69a"
  },
  {
    "url": "/_next/static/chunks/webpack-8092fa1cf3aac69a.js.map",
    "revision": "f8105cc8d035c6fcf3b43f76037a8cb5"
  },
  {
    "url": "/_next/static/css/01c7bd03561423ce.css",
    "revision": "01c7bd03561423ce"
  },
  {
    "url": "/_next/static/css/01c7bd03561423ce.css.map",
    "revision": "4218efab8cc775ab18af114c53f564f8"
  },
  {
    "url": "/_next/static/css/698889fc4fd504e9.css",
    "revision": "698889fc4fd504e9"
  },
  {
    "url": "/_next/static/css/698889fc4fd504e9.css.map",
    "revision": "921bc2100e4030c6778c7d0e7b05e928"
  },
  {
    "url": "/_next/static/css/6ece48a181204804.css",
    "revision": "6ece48a181204804"
  },
  {
    "url": "/_next/static/css/6ece48a181204804.css.map",
    "revision": "7069125d42aa36aa72b12c330730404c"
  },
  {
    "url": "/_next/static/css/b1c243953ec2dbe2.css",
    "revision": "b1c243953ec2dbe2"
  },
  {
    "url": "/_next/static/css/b1c243953ec2dbe2.css.map",
    "revision": "1ebac93bf2c78845704e8ff68786a82e"
  },
  {
    "url": "/_next/static/css/b8e302d41b271438.css",
    "revision": "b8e302d41b271438"
  },
  {
    "url": "/_next/static/css/b8e302d41b271438.css.map",
    "revision": "cff5b46f80b3added57007adbb8c8ee2"
  },
  {
    "url": "/assets/fonts/Acumin-Pro.woff",
    "revision": "5a751715dc247d10c97a67dced86ca24"
  },
  {
    "url": "/assets/fonts/GT-Alpina-Standard-Regular.otf",
    "revision": "04d3efaa816e11d4218e48fc8b4013fc"
  },
  {
    "url": "/assets/fonts/GT-Alpina-Standard-Regular.ttf",
    "revision": "43f980b5943a876111f9d7ece3faad9d"
  },
  {
    "url": "/assets/fonts/GT-Alpina-Standard-Regular.woff",
    "revision": "a2eebb83a400086e65747b9ad7dd00b3"
  },
  {
    "url": "/assets/fonts/GT-Alpina-Standard-Regular.woff2",
    "revision": "a5cbccd6ebc949306886a1a2fbb04ab3"
  },
  {
    "url": "/assets/fonts/GT-America-Expanded-Medium.otf",
    "revision": "8a3d6ef0887565f205af98fea14ead4f"
  },
  {
    "url": "/assets/fonts/GT-America-Expanded-Medium.ttf",
    "revision": "13982ff5fa877f19712800dd3a876137"
  },
  {
    "url": "/assets/fonts/GT-America-Expanded-Medium.woff",
    "revision": "14c3fb0467beb7740830ed2dc32cae41"
  },
  {
    "url": "/assets/fonts/GT-America-Expanded-Medium.woff2",
    "revision": "dc40c5ae628e13e84b46793aa76df73f"
  },
  {
    "url": "/assets/fonts/KobeBold.eot",
    "revision": "268a5882f59eccfea18997a26b1e9be1"
  },
  {
    "url": "/assets/fonts/KobeBold.woff",
    "revision": "c542e004df5f186aa071824e32cda057"
  },
  {
    "url": "/assets/fonts/KobeBold.woff2",
    "revision": "b11fe4360bb2bdf64a9b8fe0188aa324"
  },
  {
    "url": "/assets/fonts/KobeRegular.eot",
    "revision": "6cf238ccd26cc1f6686457e6d404f004"
  },
  {
    "url": "/assets/fonts/KobeRegular.woff",
    "revision": "f56110cad6ae50a4cd57fd683cfd992e"
  },
  {
    "url": "/assets/fonts/KobeRegular.woff2",
    "revision": "f7d846568554bc44c20586d17ad154b0"
  },
  {
    "url": "/assets/fonts/StyreneB.woff",
    "revision": "ca0488b702e6b48b2f7bb3dd1e279603"
  },
  {
    "url": "/assets/img/Rita_Leaf_Desktop.gif",
    "revision": "1bf7d7d9a11028764d7b6028f2064477"
  },
  {
    "url": "/assets/img/assessment/assessment-end.png",
    "revision": "ba7751842dbc5daeb2315dde2d67a5d8"
  },
  {
    "url": "/assets/img/assessment/categories/category-career.png",
    "revision": "99d845c48423806b4b5099d4248ded6e"
  },
  {
    "url": "/assets/img/assessment/categories/category-fertility.png",
    "revision": "7d27196e938d845e2411bea5542d1550"
  },
  {
    "url": "/assets/img/assessment/categories/category-relationships.png",
    "revision": "263a6357c1c42b7c5f4ade94fc4ef0d7"
  },
  {
    "url": "/assets/img/assessment/categories/category-self-care.png",
    "revision": "30c73831a6f7a0c03d5028c8b66772ee"
  },
  {
    "url": "/assets/img/assessment/family-where-grow-up1.png",
    "revision": "561dea6ecb5d05eb3fd7aa147aae155b"
  },
  {
    "url": "/assets/img/assessment/family-where-grow-up2.png",
    "revision": "e913751e510a65cec98dbd954c72a812"
  },
  {
    "url": "/assets/img/assessment/family-where-grow-up3.png",
    "revision": "1a47230df3c453b7535744c46caa8311"
  },
  {
    "url": "/assets/img/assessment/family-where-grow-up4.png",
    "revision": "f0e3705f8118ca5a4e5d344cf09c20d8"
  },
  {
    "url": "/assets/img/assessment/fertility-feeling1.png",
    "revision": "182a5d2a436f80f4c64b941b9232a4bb"
  },
  {
    "url": "/assets/img/assessment/fertility-feeling2.png",
    "revision": "82bd44ff84ab8cf2800c4679253ed520"
  },
  {
    "url": "/assets/img/assessment/fertility-feeling3.png",
    "revision": "9044a592f2d31b886febcb1a55ee3e5d"
  },
  {
    "url": "/assets/img/assessment/fertility-feeling4.png",
    "revision": "9059998ba9506a27cc2d3d0dfa5227eb"
  },
  {
    "url": "/assets/img/assessment/fertility-feeling5.png",
    "revision": "37c65d1c81c36f10a8eca028c2bc6581"
  },
  {
    "url": "/assets/img/assessment/lifestyle-fluids1.png",
    "revision": "38c91e65372ffa75b5a9b327c7f5c6fd"
  },
  {
    "url": "/assets/img/assessment/lifestyle-fluids2.png",
    "revision": "f2c0bafb319b04708306bf838484eb0e"
  },
  {
    "url": "/assets/img/assessment/lifestyle-fluids3.png",
    "revision": "9e0c61623e0abbd5baca306a3828822b"
  },
  {
    "url": "/assets/img/assessment/lifestyle-fluids4.png",
    "revision": "621c5f7f2f14a8fe140820c8ba93d0fb"
  },
  {
    "url": "/assets/img/assessment/medical-teeth1.png",
    "revision": "50c89b94d94b69c403beedfec0f94ef5"
  },
  {
    "url": "/assets/img/assessment/medical-teeth2.png",
    "revision": "2da24ab731fa206e63afd30ccdf2d496"
  },
  {
    "url": "/assets/img/assessment/medical-teeth3.png",
    "revision": "09e99a17b299f1b68717c0d29e706bea"
  },
  {
    "url": "/assets/img/assessment/medical-teeth4.png",
    "revision": "9588802db21d73b3ba166beba5da9a35"
  },
  {
    "url": "/assets/img/assessment/period-cramps1.png",
    "revision": "88698272a0cd1a96aa1511d7e5d8ea94"
  },
  {
    "url": "/assets/img/assessment/period-cramps2.png",
    "revision": "047aae660f2d10cbeefcd57dc3c6b101"
  },
  {
    "url": "/assets/img/assessment/period-cramps2a.png",
    "revision": "047aae660f2d10cbeefcd57dc3c6b101"
  },
  {
    "url": "/assets/img/assessment/period-cramps3.png",
    "revision": "7960e0c510cee34e1d0c79f9431dc97d"
  },
  {
    "url": "/assets/img/assessment/period-cramps4.png",
    "revision": "79f43b454d986e6a9209e09c56c00210"
  },
  {
    "url": "/assets/img/assessment/period-cramps5.png",
    "revision": "404fcfd7a876751d17480aa5d43dea81"
  },
  {
    "url": "/assets/img/assessment/quotes/ali.jpg",
    "revision": "e536cdfec2cd72f81c4dc7d49b8ad20a"
  },
  {
    "url": "/assets/img/assessment/quotes/denny-mini.jpg",
    "revision": "8aab835e0a0b52e0e37bbd6ceedfdcf9"
  },
  {
    "url": "/assets/img/assessment/quotes/desktop.ini",
    "revision": "aba21bb49e74f60ae10d91a4de11f5b7"
  },
  {
    "url": "/assets/img/assessment/quotes/lizlaf-mini.jpg",
    "revision": "df2bf2947e5c8ed141fd1f783956a415"
  },
  {
    "url": "/assets/img/assessment/quotes/lusia-mini.jpeg",
    "revision": "a1a6117beb123760772b86978a5090cd"
  },
  {
    "url": "/assets/img/assessment/quotes/sample-quote.png",
    "revision": "0863c4c44c307e022b5077acf3d42ccb"
  },
  {
    "url": "/assets/img/assessment/reproductive-sensation1.png",
    "revision": "8d48b9fa1d94e9632eb919dee3296b49"
  },
  {
    "url": "/assets/img/assessment/reproductive-sensation2.png",
    "revision": "5768a86e4caf22061aa33fc2871cfda3"
  },
  {
    "url": "/assets/img/assessment/reproductive-sensation3.png",
    "revision": "9b309e7c6d8424279f5a20a1d696386c"
  },
  {
    "url": "/assets/img/assessment/reproductive-sensation4.png",
    "revision": "e158063073c61bbb0cb1c6cc081577ed"
  },
  {
    "url": "/assets/img/assessment/ribbons/family-history-bottom-m.png",
    "revision": "95f9671a326d79c58f202ff3c94b2c5b"
  },
  {
    "url": "/assets/img/assessment/ribbons/family-history-bottom.png",
    "revision": "1c9bc2dc6175a49922993e59de9e2d36"
  },
  {
    "url": "/assets/img/assessment/ribbons/family-history-top-m.png",
    "revision": "f65db81ec9ddc6c10f846648cace31d6"
  },
  {
    "url": "/assets/img/assessment/ribbons/family-history-top.png",
    "revision": "adebc3f63dd72e8bc7a577345ab82a1f"
  },
  {
    "url": "/assets/img/assessment/ribbons/family-planning-bottom-m.png",
    "revision": "000db087af2e0cb2d88b961f9fbeed8c"
  },
  {
    "url": "/assets/img/assessment/ribbons/family-planning-bottom.png",
    "revision": "e939743c01ab97d47e564147fa5c9af0"
  },
  {
    "url": "/assets/img/assessment/ribbons/family-planning-top-m.png",
    "revision": "8d8dce0e5b1721d81ca9a153f77b1716"
  },
  {
    "url": "/assets/img/assessment/ribbons/family-planning-top.png",
    "revision": "4804a6bc4a8d5c51de4a98434cd876a0"
  },
  {
    "url": "/assets/img/assessment/ribbons/get-started-bottom-m-v2.png",
    "revision": "ae0fc503207be2b674b870174fa9d0b5"
  },
  {
    "url": "/assets/img/assessment/ribbons/get-started-bottom-v2.png",
    "revision": "d17a0a0fec4e8b559f25ccd228cb8042"
  },
  {
    "url": "/assets/img/assessment/ribbons/get-started-top-m-v2.png",
    "revision": "f34072e3e66588a5fad991eed6d4987f"
  },
  {
    "url": "/assets/img/assessment/ribbons/get-started-top-v2.png",
    "revision": "1e60210652428750b37d758bb0466507"
  },
  {
    "url": "/assets/img/assessment/ribbons/greeting-image-left.png",
    "revision": "7dca9d64333cf6ff62114a116e5d15b2"
  },
  {
    "url": "/assets/img/assessment/ribbons/greeting-image-right.png",
    "revision": "47ee6b9f70b5a44b1f51c40e6a8cca1d"
  },
  {
    "url": "/assets/img/assessment/ribbons/lifestyle-health-bottom-m.png",
    "revision": "f377a423dd1adc0fc4ea2425a138b0ef"
  },
  {
    "url": "/assets/img/assessment/ribbons/lifestyle-health-bottom.png",
    "revision": "5d928b2c0ccd95efdb2f0c71dbe067c6"
  },
  {
    "url": "/assets/img/assessment/ribbons/lifestyle-health-top-m.png",
    "revision": "cb3bda15a32e9693aff540a291573511"
  },
  {
    "url": "/assets/img/assessment/ribbons/lifestyle-health-top.png",
    "revision": "73bbd5c97c5e4da35726e80c8118f15a"
  },
  {
    "url": "/assets/img/assessment/ribbons/medical-history-bottom-m.png",
    "revision": "0fbfe87d326d8f87d2145f68f795aa2f"
  },
  {
    "url": "/assets/img/assessment/ribbons/medical-history-bottom.png",
    "revision": "b689bdfbfa0eada5491641b1dbc35fa0"
  },
  {
    "url": "/assets/img/assessment/ribbons/medical-history-top-m.png",
    "revision": "7e7590ddfb13956688b93842a4b52d9e"
  },
  {
    "url": "/assets/img/assessment/ribbons/medical-history-top.png",
    "revision": "a37584e08d94b959d56660092b3498b2"
  },
  {
    "url": "/assets/img/assessment/ribbons/mental-health-bottom-m.png",
    "revision": "6d24039c73a129cb9260afd174b664f2"
  },
  {
    "url": "/assets/img/assessment/ribbons/mental-health-bottom.png",
    "revision": "2ba4fe265826e42d48ed1408289c6f12"
  },
  {
    "url": "/assets/img/assessment/ribbons/mental-health-top-m.png",
    "revision": "2282fa49a9e99310077c1f0a77c2ab9d"
  },
  {
    "url": "/assets/img/assessment/ribbons/mental-health-top.png",
    "revision": "a6fde3421074395a4bfdae556c4ea27c"
  },
  {
    "url": "/assets/img/assessment/ribbons/period-health-bottom-m.png",
    "revision": "3a90a573553895d8bde70af808e543bc"
  },
  {
    "url": "/assets/img/assessment/ribbons/period-health-bottom.png",
    "revision": "b718e281d1f94adf2569742a82f88d62"
  },
  {
    "url": "/assets/img/assessment/ribbons/period-health-top-m.png",
    "revision": "b0d6b92840f6cb93927dd1a87ac9dcda"
  },
  {
    "url": "/assets/img/assessment/ribbons/period-health-top.png",
    "revision": "78ede091fa6bb4be1ab65c7f69e68dc9"
  },
  {
    "url": "/assets/img/assessment/ribbons/reproductive-health-bottom-m.png",
    "revision": "0ed07cd9870a54070368e7dc2d148ee5"
  },
  {
    "url": "/assets/img/assessment/ribbons/reproductive-health-bottom.png",
    "revision": "836d75df1f640223daa423e8a5ab675e"
  },
  {
    "url": "/assets/img/assessment/ribbons/reproductive-health-top-m.png",
    "revision": "81f4eb6c4aeba5d7e07f99c591e81911"
  },
  {
    "url": "/assets/img/assessment/ribbons/reproductive-health-top.png",
    "revision": "8a14822be8992c15773ca118a1a9a4ac"
  },
  {
    "url": "/assets/img/assessment/ribbons/sexual-health-bottom-m.png",
    "revision": "be20265566da23b031a77a91ee5f1d88"
  },
  {
    "url": "/assets/img/assessment/ribbons/sexual-health-bottom.png",
    "revision": "63bec24b247c63abb8b89a57d4174f3f"
  },
  {
    "url": "/assets/img/assessment/ribbons/sexual-health-top-m.png",
    "revision": "7130dab18c9ce1bdb142572c359f8419"
  },
  {
    "url": "/assets/img/assessment/ribbons/sexual-health-top.png",
    "revision": "15f522d22d2be7c49db99366dfbfecbb"
  },
  {
    "url": "/assets/img/assessment/sample1.png",
    "revision": "a42bcb1b17c27a447f867fa899fb3dc0"
  },
  {
    "url": "/assets/img/assessment/sample2.png",
    "revision": "adacdacce982430ebd5c20ce0bd412eb"
  },
  {
    "url": "/assets/img/assessment/sample3.png",
    "revision": "e8726382a56b91034d685c1a192edec3"
  },
  {
    "url": "/assets/img/assessment/sample4.png",
    "revision": "d647291dfaedd4d551a87c21abb49872"
  },
  {
    "url": "/assets/img/assessment/sexual-desire1.png",
    "revision": "1d0286d09004b320838223e95f2cdafa"
  },
  {
    "url": "/assets/img/assessment/sexual-desire2.png",
    "revision": "98317b840c8d7fab89242d28742d78cf"
  },
  {
    "url": "/assets/img/assessment/sexual-desire3.png",
    "revision": "2b6cadebaab6c313a3d8e2b9e34325ad"
  },
  {
    "url": "/assets/img/assessment/sexual-desire4.png",
    "revision": "fd846fad813bb0452c7c902afdad1561"
  },
  {
    "url": "/assets/img/assessment/sexual-desire5.png",
    "revision": "b3ffd93c73e6f565ffea795961fb4fea"
  },
  {
    "url": "/assets/img/assessment/shapes/stat-bg-1.png",
    "revision": "b22f29b91f3edcc1028e8642dba57b40"
  },
  {
    "url": "/assets/img/assessment/shapes/stat-bg-2.png",
    "revision": "ffda818d7ba3c8fb6b5e7f683f2721fb"
  },
  {
    "url": "/assets/img/auth/ribbon-auth-bottom-left.png",
    "revision": "36e5ed10451601b24886a89b4a2be084"
  },
  {
    "url": "/assets/img/auth/ribbon-auth-bottom-right.png",
    "revision": "fb46b0e2dae9fbbb7ed0f4c7506f1273"
  },
  {
    "url": "/assets/img/auth/ribbon-auth-top-left.png",
    "revision": "0880097ccccb73519d2112f33a00fc4c"
  },
  {
    "url": "/assets/img/auth/ribbon-auth-top-right.png",
    "revision": "d6491bb08fcd21015ec882ed2fa7bbfc"
  },
  {
    "url": "/assets/img/auth0-bg.png",
    "revision": "ec0d460ecb1b1cbe433c9365d2662c30"
  },
  {
    "url": "/assets/img/banners/OrangeBanner-ribbon-1.png",
    "revision": "290439ca3c9c3a989371020c3aac0fd7"
  },
  {
    "url": "/assets/img/banners/OrangeBanner-ribbon-2.png",
    "revision": "6c3180e8129cf2e45875a7e16d6d638d"
  },
  {
    "url": "/assets/img/banners/OrangeQuizBanner-desktop.png",
    "revision": "93195202318b6c79d149c2d53910298d"
  },
  {
    "url": "/assets/img/banners/OrangeQuizBanner-mobile.png",
    "revision": "f046ae7f2468666b5b5c804ee8497b93"
  },
  {
    "url": "/assets/img/banners/OrangeQuoteBanner-desktop.png",
    "revision": "6f936b9fdd2e8fe957b348898de4c469"
  },
  {
    "url": "/assets/img/banners/OrangeQuoteBanner-mobile.png",
    "revision": "33c970806bea6445c2afce02e5f3551a"
  },
  {
    "url": "/assets/img/banners/PurpleQuizBanner-desktop.png",
    "revision": "1d3290a72aaaa963612a84bb72d778c1"
  },
  {
    "url": "/assets/img/banners/PurpleQuizBanner-ribbon-1.png",
    "revision": "77c467dfd49a6ff39d0a40db71d9486b"
  },
  {
    "url": "/assets/img/banners/PurpleQuizBanner-ribbon-2.png",
    "revision": "28e1b2f3a39ed549b11b00c7ca54cf25"
  },
  {
    "url": "/assets/img/banners/PurpleQuizBanner-ribbon.png",
    "revision": "306619f49fb3b1ed7ea244488706d8cd"
  },
  {
    "url": "/assets/img/banners/PurpleQuoteBanner-desktop.png",
    "revision": "302817a02c91c9e17d1752805d5b7310"
  },
  {
    "url": "/assets/img/banners/PurpleQuoteBanner-mobile.png",
    "revision": "7d71708763cb10b549b9bc87f49d98d1"
  },
  {
    "url": "/assets/img/banners/yellow_0006_ribbon-07-bottom.png",
    "revision": "0eced0232cc11dfec2c29429a4dd1fae"
  },
  {
    "url": "/assets/img/banners/yellow_0006_ribbon-07-top.png",
    "revision": "8b729d1eb89fed29a7582632ebee4832"
  },
  {
    "url": "/assets/img/factors/family-background.svg",
    "revision": "e4da34cb630e22047b22ce191a5bb64e"
  },
  {
    "url": "/assets/img/factors/family-history.svg",
    "revision": "e4da34cb630e22047b22ce191a5bb64e"
  },
  {
    "url": "/assets/img/factors/family-planning.svg",
    "revision": "e5b2916680ff0b1f1453e968df1db00b"
  },
  {
    "url": "/assets/img/factors/lifestyle-health.svg",
    "revision": "3ed6f566a0e02918ee074907639edabc"
  },
  {
    "url": "/assets/img/factors/lifestyle.svg",
    "revision": "3ed6f566a0e02918ee074907639edabc"
  },
  {
    "url": "/assets/img/factors/medical-history.svg",
    "revision": "313235e6480e42ebaf3af69dcd00a69d"
  },
  {
    "url": "/assets/img/factors/mental-health.svg",
    "revision": "8c7cf2adebbb1882c538e89924c13d90"
  },
  {
    "url": "/assets/img/factors/period-health-wh.svg",
    "revision": "78cc9bf5fe40e1a74c12a4df25f1ce80"
  },
  {
    "url": "/assets/img/factors/period-health.svg",
    "revision": "2454b60d2554f0f5645592f1fb78c5b5"
  },
  {
    "url": "/assets/img/factors/reproductive-health.svg",
    "revision": "34ec348455950505022b7e72ba18cfc0"
  },
  {
    "url": "/assets/img/factors/sexual-health.svg",
    "revision": "414b9bd266c38ab592cdb95426596472"
  },
  {
    "url": "/assets/img/factors/sexual-wellbeing.svg",
    "revision": "414b9bd266c38ab592cdb95426596472"
  },
  {
    "url": "/assets/img/faq/form-ribbon.png",
    "revision": "384d66df6e54ed0b2215639adbf41cfc"
  },
  {
    "url": "/assets/img/faq/hero-back.png",
    "revision": "d7701983e240bff16df6668b07ff0bba"
  },
  {
    "url": "/assets/img/faq/hero.png",
    "revision": "459d53db2f77b7927d9c6c6a1ecb193f"
  },
  {
    "url": "/assets/img/faq/sun.png",
    "revision": "5ae4e0c42c438eaf63918102efa83f99"
  },
  {
    "url": "/assets/img/graphs/example-chart.svg",
    "revision": "9d36e2c070f797a0aa1838e4688ac617"
  },
  {
    "url": "/assets/img/graphs/family history chart.svg",
    "revision": "5c444de5b9bef55ea08960b0561db26b"
  },
  {
    "url": "/assets/img/graphs/family planning chart.svg",
    "revision": "967099f376a8b67914ce39c391a2d5c3"
  },
  {
    "url": "/assets/img/graphs/lifestyle chart.svg",
    "revision": "7d939be840088cad2d884e691772cda4"
  },
  {
    "url": "/assets/img/graphs/medical history chart.svg",
    "revision": "ef121da33b063664a97de41790ab2b55"
  },
  {
    "url": "/assets/img/graphs/mental health chart.svg",
    "revision": "9ba3ec758039e122b3f5c8c42e1bb0d3"
  },
  {
    "url": "/assets/img/graphs/period health chart.svg",
    "revision": "c8b60a523f1d127804f74639104a7723"
  },
  {
    "url": "/assets/img/graphs/reproductive health chart.svg",
    "revision": "98b2012900ebfafb044823abacc565e2"
  },
  {
    "url": "/assets/img/graphs/sexual wellbeing chart.svg",
    "revision": "a27131cf96344ff4304cd55826c8bdb4"
  },
  {
    "url": "/assets/img/header-ribbon-1.png",
    "revision": "fba427ed8131fa93be36f0971d0673ef"
  },
  {
    "url": "/assets/img/header-ribbon-2.png",
    "revision": "bbadffe9cad0bed2a3509c0a7f726945"
  },
  {
    "url": "/assets/img/header-ribbon-3.png",
    "revision": "85cce476d5e70877a78d2423d558fe18"
  },
  {
    "url": "/assets/img/home-v2/bright-yellow-shape.svg",
    "revision": "319e0c3204a88fda78dbed09e0abd7f6"
  },
  {
    "url": "/assets/img/home-v2/feature-1.svg",
    "revision": "d76e3fc96fbde42703de8ce131c40662"
  },
  {
    "url": "/assets/img/home-v2/feature-2.svg",
    "revision": "4c94e065e77f11af5f8798defc8e376e"
  },
  {
    "url": "/assets/img/home-v2/highlight-icon-1.svg",
    "revision": "580f34364b61f9dafc28b7b3985a719c"
  },
  {
    "url": "/assets/img/home-v2/highlight-icon-2.svg",
    "revision": "449c6b5e3f9a02fff6ec6690f37b941a"
  },
  {
    "url": "/assets/img/home-v2/highlight-icon-3.svg",
    "revision": "82df618c31cd8042a3963317b6f8c3b3"
  },
  {
    "url": "/assets/img/home-v2/lilac-shape-01.svg",
    "revision": "a26de50e25bbcbcad30dbd6b89eea98e"
  },
  {
    "url": "/assets/img/home-v2/lilac-shape-02.svg",
    "revision": "563363a9429384cad5613b982e84c1c2"
  },
  {
    "url": "/assets/img/home-v2/lilac-small-price.svg",
    "revision": "0ed09d334385032455fbc7ae175df35d"
  },
  {
    "url": "/assets/img/home-v2/melon-shape.svg",
    "revision": "f432c265a1a9e864397bb067ed66f33a"
  },
  {
    "url": "/assets/img/home-v2/orange-shape.svg",
    "revision": "9e48cffa1b27fa4ce46d7d54484cc5c5"
  },
  {
    "url": "/assets/img/home-v2/pre-order-hero-bg.svg",
    "revision": "40b1a4c2f490a8a5add0207c6647641b"
  },
  {
    "url": "/assets/img/home-v2/red-shape.svg",
    "revision": "690eb2ce47a6b3c6e44a57291a22394c"
  },
  {
    "url": "/assets/img/home-v2/rita-logo.svg",
    "revision": "f2ba82af6c68628f7a7317803400a169"
  },
  {
    "url": "/assets/img/home-v2/step-1.png",
    "revision": "a750550ff2e5102b80768664607ecc5b"
  },
  {
    "url": "/assets/img/home-v2/step-2.png",
    "revision": "e9cb9f0353418f30be3667fcde0d8137"
  },
  {
    "url": "/assets/img/home-v2/step-3.png",
    "revision": "f3467c628f0604a2dbd525e75ff2bd93"
  },
  {
    "url": "/assets/img/home-v2/woman.png",
    "revision": "0fb792aecd21c9cb463d03240dff7064"
  },
  {
    "url": "/assets/img/home-v2/yellow-small-price.svg",
    "revision": "ea5bbc900fa44aa3d13c057af70415c0"
  },
  {
    "url": "/assets/img/home/hero-back.png",
    "revision": "327b6fff8cf5f887c876260bce2cd263"
  },
  {
    "url": "/assets/img/home/hero-front.png",
    "revision": "bdb35cb9cccf9669bf96c9bc72480e18"
  },
  {
    "url": "/assets/img/home/hero-natalia.png",
    "revision": "76830cf11b862845fa348d3be3655bf2"
  },
  {
    "url": "/assets/img/home/hero-product-2.png",
    "revision": "42bbfa36a95918a901ade7242c97b86f"
  },
  {
    "url": "/assets/img/home/hero-product.png",
    "revision": "e735c1d9e63d1279fcc1b0f9310524b4"
  },
  {
    "url": "/assets/img/home/hero.png",
    "revision": "a18315ed73881f1cab858af8b357037a"
  },
  {
    "url": "/assets/img/home/how-it-works-back.png",
    "revision": "82f270817bdf73ee09d230450fe84952"
  },
  {
    "url": "/assets/img/home/how-it-works-front.png",
    "revision": "f51a16edba28c9766b084b9d5e6108c8"
  },
  {
    "url": "/assets/img/home/icon-1.png",
    "revision": "38fc451b6189cb1776b2455ada21c49d"
  },
  {
    "url": "/assets/img/home/icon-2.png",
    "revision": "137ef960531ff7dbf614c62eedff0492"
  },
  {
    "url": "/assets/img/home/icon-3.png",
    "revision": "9bc3528e44279e3750ed5844f3c1db62"
  },
  {
    "url": "/assets/img/home/mobile-1.png",
    "revision": "29415d1fd69d4a7ee6b0f384d7185f1d"
  },
  {
    "url": "/assets/img/home/mobile-2.png",
    "revision": "4c5d00ac2b116fa0710794f097ab8145"
  },
  {
    "url": "/assets/img/home/mobile-3.png",
    "revision": "1b4da918bf1c854edcf30fc15751b087"
  },
  {
    "url": "/assets/img/home/newsletter-shapes.png",
    "revision": "d1ccb7fe5f611b61176167c1e8ba4b6e"
  },
  {
    "url": "/assets/img/home/quiz-back.png",
    "revision": "dd6a223a5d6d109eb33f9c06d4f7a7d9"
  },
  {
    "url": "/assets/img/home/quiz-front.png",
    "revision": "b8f62fa8d4778bc000d8604a0e147174"
  },
  {
    "url": "/assets/img/home/step-1.png",
    "revision": "ab1079212af64d5888e38c9b9565281c"
  },
  {
    "url": "/assets/img/home/step-2.png",
    "revision": "bb362caf08863d668df832c7b9c38871"
  },
  {
    "url": "/assets/img/home/step-3.png",
    "revision": "135217a2e74e5e929f3af96a73ab1de4"
  },
  {
    "url": "/assets/img/how-it-works/curiosity-ribbon-back.png",
    "revision": "9f10fa4d89d5983c86158826ec4a01ad"
  },
  {
    "url": "/assets/img/how-it-works/curiosity-ribbon-front.png",
    "revision": "b70f41843cdf2c892deb7407c1c484ca"
  },
  {
    "url": "/assets/img/how-it-works/fact-1.png",
    "revision": "7e47d0f3b591bb4bcd2f62e51d1e3394"
  },
  {
    "url": "/assets/img/how-it-works/fact-2.png",
    "revision": "96ee43d733cb89dfa07400805f587646"
  },
  {
    "url": "/assets/img/how-it-works/fact-3.png",
    "revision": "72e7807454d8b958899347fe3939931c"
  },
  {
    "url": "/assets/img/how-it-works/facts.png",
    "revision": "addc0fa35f15fb5298c9820cf3d1a3c8"
  },
  {
    "url": "/assets/img/how-it-works/hero-back.png",
    "revision": "0e5b291f1100cc2addbc85b0bfe6004a"
  },
  {
    "url": "/assets/img/how-it-works/hero.png",
    "revision": "cc682b1ee7e9403f2d5eca02e6696c77"
  },
  {
    "url": "/assets/img/how-it-works/mobile-1.png",
    "revision": "ed0c3aaca42c4e10385265312ee5af90"
  },
  {
    "url": "/assets/img/how-it-works/mobile-2.png",
    "revision": "1df47624c5f51443785ebb6e55d82880"
  },
  {
    "url": "/assets/img/how-it-works/mobile-3.png",
    "revision": "88a24c050ae1d4c47324ca32f711a7c3"
  },
  {
    "url": "/assets/img/icons/AppleShare.png",
    "revision": "266fd469eb6e07c09ed3acd49892f3b7"
  },
  {
    "url": "/assets/img/icons/arrow-left.svg",
    "revision": "b8bf3f80fca3ae96036609abd7a4b9e8"
  },
  {
    "url": "/assets/img/icons/arrow-right-new.svg",
    "revision": "6c64fc52ddbfece8b4870c6eebdabf8c"
  },
  {
    "url": "/assets/img/icons/arrow-right.svg",
    "revision": "88b7494e3619011839b37e2461d48cf8"
  },
  {
    "url": "/assets/img/icons/family-history.svg",
    "revision": "cc768e950e4ebe4e7dcd414f011db847"
  },
  {
    "url": "/assets/img/icons/family-planning.svg",
    "revision": "db1a05827c2ca762c52012c531551faf"
  },
  {
    "url": "/assets/img/icons/lifestyle.svg",
    "revision": "fe93c7c0627e268cdd079b128192cc94"
  },
  {
    "url": "/assets/img/icons/lock.svg",
    "revision": "3466e6becd957a0ccf4cc975fb64f29e"
  },
  {
    "url": "/assets/img/icons/medical-history.svg",
    "revision": "eca3d19f835d082ee8f72834cca373c2"
  },
  {
    "url": "/assets/img/icons/mental-health.svg",
    "revision": "c0fe21415bfa5011e8a40dcdc4373559"
  },
  {
    "url": "/assets/img/icons/mira-logo.svg",
    "revision": "d4a04152772d12aed68de1e412ed4835"
  },
  {
    "url": "/assets/img/icons/period-health.svg",
    "revision": "ffb8c8848b93ffae5b5ad28d232b6263"
  },
  {
    "url": "/assets/img/icons/reproductive-health.svg",
    "revision": "aaea9e20d8491b699221f7ef211b4ef6"
  },
  {
    "url": "/assets/img/icons/sexual-health.svg",
    "revision": "bad73dfdc09aaed5c66c477325392a43"
  },
  {
    "url": "/assets/img/ios-a2hs.jpg",
    "revision": "06b974d8b041108412d0175bcf13e529"
  },
  {
    "url": "/assets/img/ios-add-to-homescreen-min.png",
    "revision": "369d0e5ae93630f4c2c3b29b755d5dc0"
  },
  {
    "url": "/assets/img/ios-add-to-homescreen.png",
    "revision": "5e48eb31b6ba73fe8f50c2e612e6a578"
  },
  {
    "url": "/assets/img/ios-homescreen.png",
    "revision": "490f5bee5d5bf32bc1fa36015c7e93db"
  },
  {
    "url": "/assets/img/journey-ribbon.png",
    "revision": "65188acb755f649ecf08f57a1546e8e8"
  },
  {
    "url": "/assets/img/mobile-header-ribbon-1.png",
    "revision": "726f57d99c2fdd087ca5e129d186b3b5"
  },
  {
    "url": "/assets/img/mobile-header-ribbon-2.png",
    "revision": "2acb332dacf6d2e67257b13de79e114c"
  },
  {
    "url": "/assets/img/newsletter-shapes.png",
    "revision": "cd1b8200f95f0660b8fd967dfb093f27"
  },
  {
    "url": "/assets/img/our-story/flower.png",
    "revision": "4a331bc81a8e9e958549329db914da2a"
  },
  {
    "url": "/assets/img/our-story/heart.png",
    "revision": "7637b016560be52b5b9469d75528b9d6"
  },
  {
    "url": "/assets/img/our-story/hero-back.png",
    "revision": "9bee01785dbb8ed6cdd49b4060f0688d"
  },
  {
    "url": "/assets/img/our-story/hero.png",
    "revision": "ca09da680570ed2151c04acaef8c6e17"
  },
  {
    "url": "/assets/img/our-story/quote.png",
    "revision": "c0f86e78ab85fdd6af9ddb9cbba18be3"
  },
  {
    "url": "/assets/img/our-story/video-desktop.png",
    "revision": "16c013e2d88e65b63e63caad0ae6896f"
  },
  {
    "url": "/assets/img/our-story/video-ribbon-front.png",
    "revision": "f9744c8e5e8b51f4ef4d5db11ac71e79"
  },
  {
    "url": "/assets/img/our-story/video-ribbon.png",
    "revision": "8ede031778c36561050e75fec263f879"
  },
  {
    "url": "/assets/img/our-story/video.png",
    "revision": "427ad385005f6fad0e776cdab8682a62"
  },
  {
    "url": "/assets/img/paywall/4-half-stars.svg",
    "revision": "dff73fc4f79afdda9b3dd10d86ead845"
  },
  {
    "url": "/assets/img/paywall/5-stars.svg",
    "revision": "912b3fe3c94158a028d3beb54f544fb4"
  },
  {
    "url": "/assets/img/paywall/bottom right.png",
    "revision": "fe62517e835350df15658a1d538aeeb5"
  },
  {
    "url": "/assets/img/paywall/clearer-view.png",
    "revision": "6f17e6cdf5ab4c4cb9884acf82c2285b"
  },
  {
    "url": "/assets/img/paywall/denny.png",
    "revision": "d4d54dee93da118c1ed7ce09973f8ad4"
  },
  {
    "url": "/assets/img/paywall/dorothee.png",
    "revision": "4e6b85b2a8dda3be3d200831763e9c24"
  },
  {
    "url": "/assets/img/paywall/eight-detailed-report.png",
    "revision": "bba5e07e44075beb166cc63f3044442b"
  },
  {
    "url": "/assets/img/paywall/insights.png",
    "revision": "22a10b4e7c195cadea26601bed4af279"
  },
  {
    "url": "/assets/img/paywall/lizellen.png",
    "revision": "efde9e2d52d888e615377748c7962c65"
  },
  {
    "url": "/assets/img/paywall/lusine.png",
    "revision": "ceddbeaae717fe9ef1147d9e4b43960c"
  },
  {
    "url": "/assets/img/paywall/paywall-intro-1.png",
    "revision": "649d62fd55b2a7a69d889c040374dcbf"
  },
  {
    "url": "/assets/img/paywall/paywall-intro-2.png",
    "revision": "a4181ea8a20f0ba57c065a1a5fc291f6"
  },
  {
    "url": "/assets/img/paywall/paywall-intro-3.png",
    "revision": "2dce1b5c754f9eb0d64a3d12521ca637"
  },
  {
    "url": "/assets/img/paywall/paywall-intro-image.png",
    "revision": "6872ec48cc1d245734de7a5df812e57c"
  },
  {
    "url": "/assets/img/paywall/paywall-ribbon-mobile.png",
    "revision": "24770f89a9b6fb64902b22c443285b1f"
  },
  {
    "url": "/assets/img/paywall/paywall-success-ribbon-bottom.png",
    "revision": "31ef11ffc99a45d050dca776e86dd0dc"
  },
  {
    "url": "/assets/img/paywall/paywall-success-ribbon-top.png",
    "revision": "860f0442cba23038e778efa9ad977b3d"
  },
  {
    "url": "/assets/img/paywall/paywall-success-sun.gif",
    "revision": "fed46b9eaf8ad4a13be9b014494806e6"
  },
  {
    "url": "/assets/img/paywall/quote-ribbon.png",
    "revision": "c20d64e0310b274716da130466228eea"
  },
  {
    "url": "/assets/img/paywall/testimonial-ribbon-1.png",
    "revision": "6282b752c5bd40fad0398961cde1407d"
  },
  {
    "url": "/assets/img/paywall/testimonial-ribbon-2.png",
    "revision": "bfb79a4f45648f718176720691785e83"
  },
  {
    "url": "/assets/img/paywall/testimonial-ribbon-3.png",
    "revision": "c5914bf463ff3221a8f63d1b62426833"
  },
  {
    "url": "/assets/img/paywall/top-left.png",
    "revision": "0f2dd84d97e72aeb05510b311ff8544f"
  },
  {
    "url": "/assets/img/people/aghajanova.png",
    "revision": "e32df35d2e31d6dbe76b94c6dd54b546"
  },
  {
    "url": "/assets/img/people/baker.png",
    "revision": "8e9806c5521eb6d3e421a9e6dd20a4fb"
  },
  {
    "url": "/assets/img/people/bartels.png",
    "revision": "260509f86b23e665b12b6dad29d51aad"
  },
  {
    "url": "/assets/img/people/canton.png",
    "revision": "fbc5ac0f1ba6daf746002275d44bfdbe"
  },
  {
    "url": "/assets/img/people/carew.png",
    "revision": "65f9afeb50e8711257c0c797a7bbaf45"
  },
  {
    "url": "/assets/img/people/gosnell.png",
    "revision": "bd334cf79c316e942c8be896b9256f5f"
  },
  {
    "url": "/assets/img/people/hallahan.png",
    "revision": "c4869f85b9eb53d8c73d570e941c7968"
  },
  {
    "url": "/assets/img/people/harden.png",
    "revision": "720ee2b939ad1af39d61225e13757dc2"
  },
  {
    "url": "/assets/img/people/king.png",
    "revision": "fb889c0baa4ecdc25fb9d34d7bc9c2b0"
  },
  {
    "url": "/assets/img/people/la-follette.png",
    "revision": "ee89654f967956255b0d91a6eacb2ac0"
  },
  {
    "url": "/assets/img/people/leffler.png",
    "revision": "334b2942db21d8703d6a2265c87f3830"
  },
  {
    "url": "/assets/img/people/medwid.png",
    "revision": "ec85b328103cc4931bcd1679b7c927d8"
  },
  {
    "url": "/assets/img/people/morichi.png",
    "revision": "6591e50da782cd5cefd63bf3c0a13d5b"
  },
  {
    "url": "/assets/img/people/noone.png",
    "revision": "be5b424916c05a551c242435a043b2d0"
  },
  {
    "url": "/assets/img/people/nussbaum.png",
    "revision": "dbe5d398b9e59ad04a7d4a40c6f36364"
  },
  {
    "url": "/assets/img/people/oleszczuk.png",
    "revision": "2aa15575faa277a5ab9f2c64caa09515"
  },
  {
    "url": "/assets/img/people/sakkas.png",
    "revision": "6a8720e0ab0e90ef1a435bf7ddbd8086"
  },
  {
    "url": "/assets/img/people/staryga.png",
    "revision": "16120d2ecb11059c2be56f3001ca8108"
  },
  {
    "url": "/assets/img/people/targonskaya.png",
    "revision": "038499264ca59b8f83aed5113e9c138e"
  },
  {
    "url": "/assets/img/people/vinod.png",
    "revision": "b0ba7c91cbd3e15565b7d441876289dc"
  },
  {
    "url": "/assets/img/people/weinberger.png",
    "revision": "65b4990a4b9969f76f5605a1298d748f"
  },
  {
    "url": "/assets/img/products/career-coach-v2.png",
    "revision": "20e55a596786916734312363bbf5c30e"
  },
  {
    "url": "/assets/img/products/career-coach-v3.png",
    "revision": "b9bf22d8e5ba7eb1a8b629ddc63631ef"
  },
  {
    "url": "/assets/img/products/evvy-chylamidia.webp",
    "revision": "fb730fb308e925075e78fe735a13e895"
  },
  {
    "url": "/assets/img/products/evvy-vaginal-health.webp",
    "revision": "fb730fb308e925075e78fe735a13e895"
  },
  {
    "url": "/assets/img/products/fertility-clarity-kit.webp",
    "revision": "d2623aa9c6e03cf784075165fd67777b"
  },
  {
    "url": "/assets/img/products/fertility-max-starter-kit.webp",
    "revision": "2e4fbcc9d38b17aec9606c3b694e2af1"
  },
  {
    "url": "/assets/img/products/fertility-tea.webp",
    "revision": "e470202e0bd5b1e1676ec1bf028ef070"
  },
  {
    "url": "/assets/img/products/mira-hormone-clinic.png",
    "revision": "9dbd8df73700a15708b402f7a4d17c6b"
  },
  {
    "url": "/assets/img/products/mira-max-ovum-bundle.webp",
    "revision": "d2623aa9c6e03cf784075165fd67777b"
  },
  {
    "url": "/assets/img/products/mira-panorama.webp",
    "revision": "6a527eba8841a188d03f62ce26f536a7"
  },
  {
    "url": "/assets/img/products/obgyn-v2.png",
    "revision": "81f7275506e29bedf00b294a76748ccf"
  },
  {
    "url": "/assets/img/products/obgyn-v3.png",
    "revision": "49fc8a37a9defced175bbedd60e9289f"
  },
  {
    "url": "/assets/img/products/pcos-supplements.webp",
    "revision": "af6fb64d7d55ea3cfa7293ab557097ee"
  },
  {
    "url": "/assets/img/products/prenatal-multivitamin.webp",
    "revision": "bd5c2033c785c4f81d0e7a6485ece276"
  },
  {
    "url": "/assets/img/products/proov-complete.webp",
    "revision": "c3a73f1338edb0028b4f78a5860cdc93"
  },
  {
    "url": "/assets/img/products/relationship-coach-v3.png",
    "revision": "dc541be688f1a908b1413aa23d15cc32"
  },
  {
    "url": "/assets/img/products/releationship-coach-v2.png",
    "revision": "c65193d77bcdd711b57f60040ec83d88"
  },
  {
    "url": "/assets/img/products/sperm-test.png",
    "revision": "4dfa0ac83cd30f3bbc8c024baddf63c5"
  },
  {
    "url": "/assets/img/products/sperm-test.webp",
    "revision": "749a5e1d3018a04c8078de3e717fec36"
  },
  {
    "url": "/assets/img/profile/ali.jpg",
    "revision": "e536cdfec2cd72f81c4dc7d49b8ad20a"
  },
  {
    "url": "/assets/img/profile/denny-mini.jpg",
    "revision": "8aab835e0a0b52e0e37bbd6ceedfdcf9"
  },
  {
    "url": "/assets/img/profile/lizlaf-mini.jpg",
    "revision": "df2bf2947e5c8ed141fd1f783956a415"
  },
  {
    "url": "/assets/img/profile/lusia-mini.jpeg",
    "revision": "a1a6117beb123760772b86978a5090cd"
  },
  {
    "url": "/assets/img/profile/sample-quote.png",
    "revision": "0863c4c44c307e022b5077acf3d42ccb"
  },
  {
    "url": "/assets/img/profile/sample.png",
    "revision": "47483dd315c130d42d2d85fd96e02b61"
  },
  {
    "url": "/assets/img/quote-ribbon-mobile.png",
    "revision": "889038d5338a6bfeddc3864c364cd244"
  },
  {
    "url": "/assets/img/report/articles-all.png",
    "revision": "168b2733bf5017860a72ed549d5216a4"
  },
  {
    "url": "/assets/img/report/headers/family-history-left.png",
    "revision": "79b677b388c5a11f8cfff7f44b7f987f"
  },
  {
    "url": "/assets/img/report/headers/family-history-right.png",
    "revision": "99392dac7985cc1c307521b5883355bc"
  },
  {
    "url": "/assets/img/report/headers/family-planning-left.png",
    "revision": "f976fd4f2b173037b1f7c86585a632c7"
  },
  {
    "url": "/assets/img/report/headers/family-planning-right.png",
    "revision": "7da2588122b07afe893f1cb241dc224c"
  },
  {
    "url": "/assets/img/report/headers/in-depth-report-left.png",
    "revision": "58f20658aeb4790507fc102575005186"
  },
  {
    "url": "/assets/img/report/headers/in-depth-report-right.png",
    "revision": "ecf861c970bf588d4ec591c2e430fd0a"
  },
  {
    "url": "/assets/img/report/headers/lifestyle-health-left.png",
    "revision": "8205b5e0071136e7fae6fddb18db2772"
  },
  {
    "url": "/assets/img/report/headers/lifestyle-health-right.png",
    "revision": "d4e022e25b97345c7360eca7429932dd"
  },
  {
    "url": "/assets/img/report/headers/medical-history-left.png",
    "revision": "fc74aa03d31b84e1bb919e2a51a12a89"
  },
  {
    "url": "/assets/img/report/headers/medical-history-right.png",
    "revision": "1f07c74a10b4144ea0b9893c4bbdf7de"
  },
  {
    "url": "/assets/img/report/headers/mental-health-left.png",
    "revision": "00a74e82ca64ebd416b82012d7dacf3c"
  },
  {
    "url": "/assets/img/report/headers/mental-health-right.png",
    "revision": "d41ea353fbd73b0aafc86dae145068d6"
  },
  {
    "url": "/assets/img/report/headers/period-health-left.png",
    "revision": "835b72cd1242dbfd35d482aee7679a29"
  },
  {
    "url": "/assets/img/report/headers/period-health-right.png",
    "revision": "728c074bdc28598404bd6dcd36286a78"
  },
  {
    "url": "/assets/img/report/headers/reproductive-health-left.png",
    "revision": "dae8eca01dfc9027a3a2f72e23ef5112"
  },
  {
    "url": "/assets/img/report/headers/reproductive-health-right.png",
    "revision": "a74d740d5a8739cb4db79bd8541a62c1"
  },
  {
    "url": "/assets/img/report/headers/sexual-health-left.png",
    "revision": "192f9a66e739a1acd6b89d2afeeea2ad"
  },
  {
    "url": "/assets/img/report/headers/sexual-health-right.png",
    "revision": "6a70a039618fc1d42253c68a2297a306"
  },
  {
    "url": "/assets/img/report/next-steps-all.png",
    "revision": "a6df1cf4e74e2ecbba3f58f279de6ff2"
  },
  {
    "url": "/assets/img/report/our-study-stat-bg.svg",
    "revision": "36a0f0f9b56c5034f4225e00dad10642"
  },
  {
    "url": "/assets/img/report/reports-all.png",
    "revision": "644f9205ab446a7f5b5c3e66062989cd"
  },
  {
    "url": "/assets/img/report/research-bg-desktop.png",
    "revision": "60e27a2ed570822985b991e926b55d9b"
  },
  {
    "url": "/assets/img/ribbon-dashboard-mobile.png",
    "revision": "248baf2a7f7f69a11fd85145937efa98"
  },
  {
    "url": "/assets/img/rita-logo.svg",
    "revision": "5d99c9a55886c89bf96eedbed3747470"
  },
  {
    "url": "/assets/img/science/chart.png",
    "revision": "17da5c57cde605819945c92c77f9733b"
  },
  {
    "url": "/assets/img/science/factors-fertilitity.gif",
    "revision": "d1440537bf44d0f826cd0bad0a91a767"
  },
  {
    "url": "/assets/img/science/gauge.png",
    "revision": "42bafbb5d30d05d27b74585d1becde78"
  },
  {
    "url": "/assets/img/science/hero-back.png",
    "revision": "62e33daa5de369c9c809905123338ef2"
  },
  {
    "url": "/assets/img/science/hero-front.png",
    "revision": "830f9db36a31b331610aceb5a5f9e5d9"
  },
  {
    "url": "/assets/img/science/hero.png",
    "revision": "fc34848a248e6faa8f884349128f2575"
  },
  {
    "url": "/assets/img/science/icon-1.png",
    "revision": "388764a2783639e13bc08e4a95da6526"
  },
  {
    "url": "/assets/img/science/icon-2.png",
    "revision": "0d905263e0d2e7314fd194bb8e96bd14"
  },
  {
    "url": "/assets/img/science/icon-3.png",
    "revision": "993829da81ac0305407443a2dfe4fe37"
  },
  {
    "url": "/assets/img/science/icon-4.png",
    "revision": "99e0bd35b362bbbde6fe50eb86ad08fc"
  },
  {
    "url": "/assets/img/science/map.png",
    "revision": "d946556f34f9f9219d599632f4746dad"
  },
  {
    "url": "/assets/img/science/principle-chart-1.png",
    "revision": "702573bae0096c62c814ca222935d872"
  },
  {
    "url": "/assets/img/science/principle-chart-2.png",
    "revision": "5c4b69885bf718ca6225fc9834388850"
  },
  {
    "url": "/assets/img/science/principle-ribbon.png",
    "revision": "4150f617c3a649356ed46bba38ac202d"
  },
  {
    "url": "/assets/img/science/quiz.png",
    "revision": "024dcb0eb8c4fb6ea0b68b2409ba368d"
  },
  {
    "url": "/assets/img/science/quote.png",
    "revision": "bc92d7cca93dd0e828b650e3b4c63514"
  },
  {
    "url": "/assets/img/social/instagram.svg",
    "revision": "10d972bb0e6823783f2b8e3b63cd9c2e"
  },
  {
    "url": "/assets/img/social/linkedin.svg",
    "revision": "6d37519e7f68368414eab477b1f60821"
  },
  {
    "url": "/assets/img/social/tiktok.svg",
    "revision": "4a5bb292ddd3c2b7f71f750def90c830"
  },
  {
    "url": "/assets/img/sprout-fertility.svg",
    "revision": "1de18ffb94c7f96225e3afdeb605acaa"
  },
  {
    "url": "/assets/img/sprout.png",
    "revision": "385b43db2d0740186b0d6a0c91887c53"
  },
  {
    "url": "/assets/img/unlock-box-ribbon-left.png",
    "revision": "3b5ffe25fe86cdc962c2888d5c92ff63"
  },
  {
    "url": "/assets/img/unlock-box-ribbon-right.png",
    "revision": "3f10aa280c01c328d53e134a6eb4fe9e"
  },
  {
    "url": "/assets/videos/hero-v2-desktop.mp4",
    "revision": "c0514b7c647391fda7973ce6c5567fe1"
  },
  {
    "url": "/assets/videos/hero-v2-mobile-new.mp4",
    "revision": "5c2f0f3f5741ea14772b77eb4c6522c2"
  },
  {
    "url": "/assets/videos/hero-v2-mobile.mp4",
    "revision": "8fa841108a4500f70f3d2e94804b9e45"
  },
  {
    "url": "/favicon.ico",
    "revision": "0be8fbeaa8dc6cd63ecad9835e689ecb"
  },
  {
    "url": "/icon-512x512.png",
    "revision": "618ef95ccd1a73834664cde23a567b1d"
  },
  {
    "url": "/icon.png",
    "revision": "e88592ef742629f1868adfa89d33d1f4"
  },
  {
    "url": "/manifest.json",
    "revision": "da419c237f683141486512251748f9e9"
  },
  {
    "url": "/robots.txt",
    "revision": "a5f8807eb8a6348d50eb605965bdf2ff"
  },
  {
    "url": "/vercel.svg",
    "revision": "4b4f1876502eb6721764637fe5c41702"
  }
], {
  "ignoreURLParametersMatching": []
});
workbox_precaching_cleanupOutdatedCaches();



workbox_routing_registerRoute("/", new workbox_strategies_NetworkFirst({ "cacheName":"start-url", plugins: [{ cacheWillUpdate: async ({ request, response, event, state }) => { if (response && response.type === 'opaqueredirect') { return new Response(response.body, { status: 200, statusText: 'OK', headers: response.headers }) } return response } }] }), 'GET');
workbox_routing_registerRoute(/^https:\/\/fonts\.(?:gstatic)\.com\/.*/i, new workbox_strategies_CacheFirst({ "cacheName":"google-fonts-webfonts", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 4, maxAgeSeconds: 31536000 })] }), 'GET');
workbox_routing_registerRoute(/^https:\/\/fonts\.(?:googleapis)\.com\/.*/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"google-fonts-stylesheets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 4, maxAgeSeconds: 604800 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:eot|otf|ttc|ttf|woff|woff2|font.css)$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"static-font-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 4, maxAgeSeconds: 604800 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:jpg|jpeg|gif|png|svg|ico|webp)$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"static-image-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 64, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\/_next\/image\?url=.+$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"next-image", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 64, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:mp3|wav|ogg)$/i, new workbox_strategies_CacheFirst({ "cacheName":"static-audio-assets", plugins: [new workbox_range_requests_RangeRequestsPlugin(), new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:mp4)$/i, new workbox_strategies_CacheFirst({ "cacheName":"static-video-assets", plugins: [new workbox_range_requests_RangeRequestsPlugin(), new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:js)$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"static-js-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:css|less)$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"static-style-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\/_next\/data\/.+\/.+\.json$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"next-data", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:json|xml|csv)$/i, new workbox_strategies_NetworkFirst({ "cacheName":"static-data-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(({ url }) => {
      const isSameOrigin = self.origin === url.origin
      if (!isSameOrigin) return false
      const pathname = url.pathname
      // Exclude /api/auth/callback/* to fix OAuth workflow in Safari without impact other environment
      // Above route is default for next-auth, you may need to change it if your OAuth workflow has a different callback route
      // Issue: https://github.com/shadowwalker/next-pwa/issues/131#issuecomment-821894809
      if (pathname.startsWith('/api/auth/')) return false
      if (pathname.startsWith('/api/')) return true
      return false
    }, new workbox_strategies_NetworkFirst({ "cacheName":"apis","networkTimeoutSeconds":10, plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 16, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(({ url }) => {
      const isSameOrigin = self.origin === url.origin
      if (!isSameOrigin) return false
      const pathname = url.pathname
      if (pathname.startsWith('/api/')) return false
      return true
    }, new workbox_strategies_NetworkFirst({ "cacheName":"others","networkTimeoutSeconds":10, plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(({ url }) => {
      const isSameOrigin = self.origin === url.origin
      return !isSameOrigin
    }, new workbox_strategies_NetworkFirst({ "cacheName":"cross-origin","networkTimeoutSeconds":10, plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 3600 })] }), 'GET');




